import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, Input, Button, Select } from '@chakra-ui/react';
import { PhrasesType } from '../Table/MaintenancePhrasesTable';
import { QueryPhrasesApi } from '../../../../apis/QueryMaintenance.api';
import { CategroyNameType } from '../../../../apis/ApiClient';
import { PhrasesSearchCondition } from '../../../../pages/PhrasesMaintenance';
import { CategorySendMessageType } from '../../../constants/MaintenanceConstants';
import { MaintenanceCompareEnum } from '../../../constants/MaintenanceConstants';

interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<PhrasesType[] | undefined>
  >;
  CategoryDatas: CategroyNameType[] | undefined;
  Query: PhrasesSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<PhrasesSearchCondition>>;
  createOrUpdate: boolean;
  SearchStateSwitch: () => void;
}

const PhrasesSearchBox: React.FC<props> = (props) => {
  const {
    setMaintenanceDatas,
    CategoryDatas,
    Query,
    setQuery,
    createOrUpdate,
    SearchStateSwitch
  } = props;

  const [category, setCategory] = useState('');
  const [phrases, setPhrases] = useState('');
  const [selectCompare, setSelectCompare] = useState(
    MaintenanceCompareEnum.Equal
  );
  const [useCount, setUseCount] = useState('');
  const [dateCreatedFrom, setDateCreatedFrom] = useState('');
  const [dateCreatedTo, setDateCreatedTo] = useState('');
  const [dateUpdatedFrom, setDateUpdatedFrom] = useState('');
  const [dateUpdatedTo, setDateUpdatedTo] = useState('');

  useEffect(() => {
    setCategory('');
    setPhrases('');
    setSelectCompare(MaintenanceCompareEnum.Equal);
    setUseCount('');
    setDateCreatedFrom('');
    setDateCreatedTo('');
    setDateUpdatedFrom('');
    setDateUpdatedTo('');
  }, [createOrUpdate]);
  const SerachGetApi = async () => {
    const params = new URLSearchParams();

    if (useCount !== '') {
      switch (selectCompare) {
        case MaintenanceCompareEnum.Equal:
          params.append('count_eq', useCount);
          break;
        case MaintenanceCompareEnum.Greater:
          params.append('count_gt', useCount);
          break;
        case MaintenanceCompareEnum.Less:
          params.append('count_lt', useCount);
          break;
      }
    }
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    category !== '' && params.append('category_id_eq', category);
    phrases !== '' && params.append('body_contains', phrases);
    Query.type !== CategorySendMessageType.None &&
      params.append('type', Query.type);
    dateCreatedFrom !== '' && params.append('created_at_gte', dateCreatedFrom);
    dateCreatedTo !== '' && params.append('created_at_lt', dateCreatedTo);
    dateUpdatedFrom !== '' && params.append('updated_at_gte', dateUpdatedFrom);
    dateUpdatedTo !== '' && params.append('updated_at_lt', dateUpdatedTo);
    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({
      ...pre,
      category: category,
      phrases: phrases,
      count: { compare: selectCompare, countData: useCount },
      selectCompare: selectCompare,
      dateCreatedFrom: dateCreatedFrom,
      dateCreatedTo: dateCreatedTo,
      dateUpdatedFrom: dateUpdatedFrom,
      dateUpdatedTo: dateUpdatedTo
    }));

    const response = await QueryPhrasesApi(apiQuery);

    if (response.success) {
      setMaintenanceDatas(response.data as PhrasesType[]);
      SearchStateSwitch();
    }
  };

  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='380px'
        bgColor='#f4f4f4'
        fontSize={14}
      >
        <Box fontSize={18} bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            カテゴリ
          </Text>
          <Select
            h='8'
            ml={2}
            bgColor='white'
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value={''}>任意</option>
            {CategoryDatas?.map((data, i) => {
              return (
                <option key={'category' + i} value={data.id}>
                  {data.category}
                </option>
              );
            })}
          </Select>
          <Text ml={2} mt={1}>
            定型文で絞り込む
          </Text>
          <Input
            h='8'
            ml={2}
            bgColor='white'
            value={phrases}
            onChange={(e) => setPhrases(e.target.value)}
          ></Input>
          <Text ml={2} mt={1}>
            利用回数
          </Text>
          <HStack>
            <Select
              h='8'
              ml={2}
              value={selectCompare}
              onChange={(e) => setSelectCompare(e.target.value)}
            >
              <option value={MaintenanceCompareEnum.Equal}>等しい</option>
              <option value={MaintenanceCompareEnum.Greater}>より大きい</option>
              <option value={MaintenanceCompareEnum.Less}>より小さい</option>
            </Select>
            <Input
              h='8'
              ml={2}
              bgColor='white'
              value={useCount}
              onChange={(e) => setUseCount(e.target.value)}
            ></Input>
          </HStack>
          <Text ml={2} mt={1}>
            登録日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedFrom}
              onChange={(e) => setDateCreatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedTo}
              onChange={(e) => setDateCreatedTo(e.target.value)}
            />
          </HStack>
          <Text ml={2} mt={1}>
            更新日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedFrom}
              onChange={(e) => setDateUpdatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedTo}
              onChange={(e) => setDateUpdatedTo(e.target.value)}
            />
          </HStack>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(PhrasesSearchBox);
